import { featureFlagKeys } from 'feature-flags/constants/featureFlags'
import { useFeatureFlag } from 'feature-flags/hooks/useFeatureFlag/useFeatureFlag'
import { getVideoSrc } from 'media/utils/getVideoSrc/getVideoSrc'
import type { DamFeatureFlagVariables } from '../../../types/types'

interface UseVideoUrlProps {
	src: string
}
export const useVideoUrl = ({ src }: UseVideoUrlProps) => {
	const { variables } = useFeatureFlag<DamFeatureFlagVariables>(
		featureFlagKeys.Dam
	)

	return {
		videoSrc: variables.isVideoEnabled ? getVideoSrc(src).href : src,
	}
}
